const cardCheckoutEnabled = () => {
  const paymentForm = document.getElementById('payment-form');
  const creditCardSection = document.getElementById('credit-card-section');
  return paymentForm && creditCardSection;
};

const fullDiscountApplied = () => {
  const paymentForm = document.getElementById('payment-form');
  const creditCardSection = document.getElementById('credit-card-section');
  const fullDiscount = paymentForm?.dataset?.fullDiscount === 'true';
  return paymentForm && !creditCardSection && fullDiscount;
};

const creditCardSubmitDisabled = (paymentSubmitBtn) => {
  const creditCardOption = document.getElementById('option_credit_card');
  return !creditCardOption.checked || paymentSubmitBtn.disabled;
};

const ebanxCheckoutEnabled = () => {
  const paymentForm = document.getElementById('payment-form');
  const ebanxEligible = paymentForm?.dataset?.ebanxEligible === 'true';
  return cardCheckoutEnabled() && ebanxEligible;
};

const razorpayCheckoutEnabled = () => {
  const paymentForm = document.getElementById('payment-form');
  return paymentForm?.dataset?.razorpayEligible === 'true';
};

const stripePaymentIntentCheckoutEnabled = () => {
  const paymentForm = document.getElementById('payment-form');
  const stripeIntentEligible = paymentForm?.dataset?.stripeIntentEligible === 'true';
  return stripeIntentEligible;
};

const paymentFormPreventSubmitOnEnterKey = (event) => {
  // We don't want payment submit to occur with a different event than a click.
  // The Enter key could be pressed with other intentions such as applying discounts.
  event.preventDefault();
};

const enableCheckoutSubmitButton = (event) => {
  setTimeout(() => {
    event.target.removeAttribute('disabled');
  }, 1000);
};

const getSelectedPaymentInstallment = () => {
  const checkedInput = document.querySelector('input[name="shop_payment_installment[number_of_installments]"]:checked');

  return checkedInput;
};

const installmentsNumber = () => {
  const checkedInput = getSelectedPaymentInstallment();

  return checkedInput?.value || 1;
};

const disableButton = (button) => {
  button.classList.add('disabled');
};

const enableButton = (button) => {
  button.classList.remove('disabled');
};

const removeFlashErrorMessage = () => {
  const alertDivs = document.querySelectorAll('div.alert-danger');
  alertDivs.forEach((alertDiv) => {
    alertDiv.classList.add('d-none');
  });
};

const updateErrorMessage = (message) => {
  const messageTextFixed = document.getElementById('stripe-error-message-fixed');
  messageTextFixed.textContent = message;
  const fixedAlert = document.getElementById('stripe-errors-fixed');
  fixedAlert.classList.remove('d-none');
  const messageTextFloating = document.getElementById('stripe-error-message-floating');
  messageTextFloating.textContent = message;
};

const createErrorMessage = (message) => {
  const sectionToRender = document.querySelector('section.container') || document.querySelector('.alerts-container');
  const newDiv = document.createElement('div');
  const messageText = document.createElement('span');
  messageText.id = 'stripe-error-message-fixed';
  messageText.textContent = message;
  newDiv.classList.add('alert', 'alert-danger');
  newDiv.appendChild(messageText);

  sectionToRender.prepend(newDiv);
};

const displayFlashErrorMessage = (message) => {
  const alertDivs = document.querySelectorAll('div.alert-danger');
  let alertDivActive = false;
  alertDivs.forEach((alertDiv) => {
    if (!alertDiv.classList.contains('d-none')) {
      const messageText = alertDiv.querySelector('[id^="stripe-error-message"]');
      if (!messageText) return;
      alertDivActive = true;
      messageText.textContent = message;
    }
  });
  if (alertDivActive) return;
  const errorDivs = Array.from(document.querySelectorAll('[id^="stripe-error-message"]'));
  if (errorDivs.length > 0) {
    updateErrorMessage(message);
  } else {
    createErrorMessage(message);
  }
};

const showFloatingErrorMessage = () => {
  const floatingAlert = document.getElementById('stripe-errors-floating');
  floatingAlert.classList.remove('d-none');
};

const hideFloatingErrorMessage = () => {
  const floatingAlert = document.getElementById('stripe-errors-floating');
  floatingAlert.classList.add('d-none');
};

const handleScroll = () => {
  const fixedAlert = document.getElementById('stripe-errors-fixed');
  const floatingAlert = document.getElementById('stripe-errors-floating');

  if (window.scrollY < 200) { // When near top of page
    fixedAlert.classList.remove('d-none');
    floatingAlert.style.visibility = 'hidden';
  } else { // When scrolled down
    fixedAlert.classList.add('d-none');
    floatingAlert.style.visibility = 'visible';
  }
};

const createPaymentHelpMainBodyCallDiv = (contactNumber) => {
  const callText = document.getElementById('payment-help-call-text');
  callText.classList.remove('d-none');
  const callLink = document.getElementById('payment-help-call-text-link');
  callLink.href = `tel:${contactNumber}`;
  callLink.textContent = contactNumber;
};

const createPaymentHelpMainBodyEmailDiv = (email, contactNumber) => {
  const emailLink = document.getElementById('payment-help-email-text-link');
  emailLink.href = `mailto:${email}`;
  emailLink.textContent = email;
  const emailText = document.getElementById('payment-help-email-text');

  if (contactNumber !== '') {
    emailText.textContent = 'Or write to us on: ';
    emailText.appendChild(emailLink);
  }
};

const addEventListenerToPaymentHelp = (paymentHelp, data) => {
  paymentHelp.addEventListener('click', () => {
    // Create modal container
    const modalContainer = document.getElementById('payment-support-modal-container');

    const closeButton = document.getElementById('payment-support-modal-close');
    closeButton.addEventListener('click', () => {
      modalContainer.classList.add('d-none');
    });

    if (data.payment_help_contact_number !== '') {
      createPaymentHelpMainBodyCallDiv(data.payment_help_contact_number);
    }

    if (data.payment_help_email !== '') {
      createPaymentHelpMainBodyEmailDiv(data.payment_help_email, data.payment_help_contact_number);
    }


    // Close modal when clicking outside
    modalContainer.addEventListener('click', (event) => {
      if (event.target === modalContainer) {
        modalContainer.classList.add('d-none');
      }
    });
    const sectionToRender = document.querySelector('section.container') || document.querySelector('.alerts-container');
    sectionToRender.appendChild(modalContainer);
  });

  return paymentHelp;
};

const addPaymentHelp = (data) => {
  const alertDivs = document.querySelectorAll('div.alert-danger');

  alertDivs.forEach((alertDiv) => {
    const paymentHelp = alertDiv.querySelector('[id^="payment-help"]');
    addEventListenerToPaymentHelp(paymentHelp, data);
  });
};

const transactionUUID = () => {
  // transactionUUID first part for Enrollment.
  // transactionUUID second part for Payment Installment.
  const transaction = document.getElementById('shop_payment_installment_transaction_uuid') || document.getElementById('transaction_uuid');

  return transaction?.value;
};

const paymentInstallmentsNotChecked = () => {
  const paymentInstallments = document.getElementsByClassName('form-radio__input');
  const optionsNotChecked = [];

  Array.from(paymentInstallments).forEach((item) => {
    if (item !== getSelectedPaymentInstallment()) { optionsNotChecked.push(item); }
  });

  return optionsNotChecked;
};

// TODO: SELL-1044
// Is important due to it is applied to the response to the payment_description endpoint
const disableItems = () => {
  const form = document.querySelector('[data-enrollment-engine--checkout-target="checkoutForm"]');

  form.classList.add('disabled');
};

// TODO: SELL-1044
// Is important due to it is applied to the response to the `/payment_description`, `stripe.js`
// and `/payment_installments` endpoint
const enableItems = () => {
  const form = document.querySelector('[data-enrollment-engine--checkout-target="checkoutForm"]');

  form.classList.remove('disabled');
};

const showBnplInstallmentTextAndHideNormalInstallments = () => {
  const bnplInsTextDiv = document.getElementById('bnpl_installment_section');
  if (bnplInsTextDiv) {
    bnplInsTextDiv.classList.remove('d-none');
  }
  const normalInsDiv = document.getElementById('non_bnpl_payment_installments');
  if (normalInsDiv) {
    normalInsDiv.classList.add('d-none');
  }
};

const hideBnplInstallmentTextAndShowNormalPaymentsInstallments = () => {
  const bnplInsTextDiv = document.getElementById('bnpl_installment_section');
  if (bnplInsTextDiv) {
    bnplInsTextDiv.classList.add('d-none');
  }
  const normalInsDiv = document.getElementById('non_bnpl_payment_installments');
  if (normalInsDiv) {
    normalInsDiv.classList.remove('d-none');
  }
};

export {
  cardCheckoutEnabled,
  fullDiscountApplied,
  ebanxCheckoutEnabled,
  razorpayCheckoutEnabled,
  creditCardSubmitDisabled,
  paymentFormPreventSubmitOnEnterKey,
  enableCheckoutSubmitButton,
  getSelectedPaymentInstallment,
  installmentsNumber,
  disableButton,
  enableButton,
  removeFlashErrorMessage,
  displayFlashErrorMessage,
  stripePaymentIntentCheckoutEnabled,
  transactionUUID,
  paymentInstallmentsNotChecked,
  disableItems,
  enableItems,
  showBnplInstallmentTextAndHideNormalInstallments,
  hideBnplInstallmentTextAndShowNormalPaymentsInstallments,
  addPaymentHelp,
  handleScroll,
  hideFloatingErrorMessage,
  showFloatingErrorMessage,
};
